module.exports = __webpack_public_path__ + "static/media/sensor.844b8513.svg";